import React, { createContext, useContext, useState, useEffect } from 'react';
import contentService from '../services/contentService';

const SiteSettingsContext = createContext({
  eBulletinActive: false,
  eBulletinRecaptchaActive: false,
  eBulletinRecaptchaSiteKey: null,
  settingsLoaded: false,
});

export const SiteSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    eBulletinActive: false,
    eBulletinRecaptchaActive: false,
    eBulletinRecaptchaSiteKey: null,
    settingsLoaded: false,
  });

  useEffect(() => {
    contentService.getSiteSettings()
      .then((data) => {
        setSettings({
          eBulletinActive: data?.EBulletinActive === true,
          eBulletinRecaptchaActive: data?.EBulletinRecaptchaActive === true,
          eBulletinRecaptchaSiteKey: data?.EBulletinRecaptchaSiteKey || null,
          settingsLoaded: true,
        });
      })
      .catch(() => {
        setSettings((prev) => ({ ...prev, settingsLoaded: true }));
      });
  }, []);

  return (
    <SiteSettingsContext.Provider value={settings}>
      {children}
    </SiteSettingsContext.Provider>
  );
};

export const useSiteSettings = () => useContext(SiteSettingsContext);
